import {
  parsePhoneNumberFromString,
  CountryCode,
} from 'libphonenumber-js';

export function validatePhoneNumber(
  phoneNumber: string,
  countryCode: string = "MX"
): string {
  const normalizedCountryCode = countryCode 
    ? (countryCode.toUpperCase() as CountryCode)
    : undefined;

  // Si el campo está vacío, es válido
  if (!phoneNumber.trim()) {
    return '';
  }

  if (/[a-zA-Z]/.test(phoneNumber)) {
    return 'No debe contener letras';
  }

  // Verificar si ya tiene lada internacional
  const hasInternationalPrefix = phoneNumber.startsWith('+') || phoneNumber.startsWith('00');

  // 1. Validar número con lada internacional
  if (hasInternationalPrefix) {
    const parsedWithLada = parsePhoneNumberFromString(phoneNumber);
    if (parsedWithLada?.isValid()) {
      return '';
    }
    return 'Número internacional inválido. Verifica el código de país y número';
  }

  // 2. Validar con countryCode si se proporcionó (para números sin lada)
  if (normalizedCountryCode) {
    const parsedWithCountry = parsePhoneNumberFromString(phoneNumber, normalizedCountryCode);
    if (parsedWithCountry?.isValid()) {
      return '';
    }
    return `Número inválido para ${normalizedCountryCode}. Verifica el número local`;
  }

  // 3. Intentar detectar automáticamente el país (para números sin lada ni countryCode)
  const commonCountries: CountryCode[] = ['MX', 'US', 'CO', 'AR', 'BR', 'ES', 'CL', 'PE'];
  for (const code of commonCountries) {
    const parsed = parsePhoneNumberFromString(phoneNumber, code);
    if (parsed?.isValid()) {
      return '';
    }
  }

  // 4. Análisis de posibles errores
  const digitsOnly = phoneNumber.replace(/\D/g, '');

  if (digitsOnly.length < 6) {
    return 'Número demasiado corto';
  }

  if (/[^\d\s\-+()]/.test(phoneNumber)) {
    return 'Contiene caracteres inválidos';
  }

  // Mensaje final si no pasó ninguna validación
  return 'Número inválido. ¿Falta el código de país? Ejemplo: +52 55 1234 5678';
}

export function isValidEmail(email: string): boolean {
  if (email === '') return true;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
